/**
 *
 * VideoEmbedly
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import playerjs from 'player.js';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Mixpanel from 'utils/mixpanelService';
import _get from 'lodash/get';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import _isEmpty from 'lodash/isEmpty';
import Config from 'utils/getEnvConfig';
import LoadingIndicator from 'components/LoadingIndicator';
import ClassNames from 'classnames';

const {
  EMBEDLY: { API_URL, API_KEY },
} = Config;

const styles = () => ({
  root: {
    '& > iframe': {
      // position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      padding: '10px 0',
    },
  },
  rootSection: {
    '& > iframe': {
      position: 'inherit',
      padding: 0,
    },
  },
  thumbnail: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 158,
  },
  bigThumbnail: {
    height: 348,
    '& > img': {
      height: 'auto',
      maxHeight: 348,
    },
  },
  smallThumbnail: {
    height: 'auto',
    '& > img': {
      height: 'auto',
      maxHeight: 158,
    },
  },
  image: {
    maxWidth: '100%',
  },
  bigVideo: {
    height: '100%',
    width: '100%',
  },
});

/* eslint-disable */
class VideoEmbedly extends React.PureComponent {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.state = {
      url: '',
      html: '',
      thumbnail_url: '',
    };
  }

  async componentDidMount() {
    const { url } = this.props;
    this.fetchImageMetadataAndSetState(url);
  }

  async componentDidUpdate(prevProps, prevState) {
    if(prevProps.url !== this.props.url) {
      this.fetchImageMetadataAndSetState(this.props.url);
    }
    const { html } = this.state;
    if (prevState.html !== html && !_isEmpty(html)) {
      this.player = new playerjs.Player(
        this.videoContainer.getElementsByTagName('iframe')[0],
      );
      this.player.on('ready', () => {
        if (this.player) {
          this.player.on('play', () => {
            this.trackEvent('Resource Page - Play');
          });
          this.player.on('pause', () => {
            this.trackEvent('Resource Page - Pause');
          });
        }
      });
    }
  }

  componentWillUnmount() {
    this.signal.cancel();
    if (this.player !== undefined) {
      this.player.off();
      this.player = undefined;
    }
  }

  fetchImageMetadataAndSetState = async(url) => {
    try {
      const params = {
        url,
        key: API_KEY,
      };
      const response = await axios.get(`${API_URL}?url=${params.url}&key=${params.key}&dnt=1&a=0`, {
        cancelToken: this.signal.token,
      });

      if (
        response.status === 200 &&
        (!_isEmpty(_get(response, 'data.html')) ||
          !_isEmpty(_get(response, 'data.url')))
      ) {
        const {
          html,
          url,
          thumbnail_url = '',
          thumbnail_width,
          thumbnail_height,
        } = response.data;
        const thumbnail =
          thumbnail_width > 300 && thumbnail_height > 120
            ? thumbnail_url
            : this.props.imageUrl;
        this.setState({ html, url, thumbnail_url: thumbnail });
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        // ignore since request was cancelled
      } else {
        this.setState({
          thumbnail_url: this.props.imageUrl,
          html: '',
          url: '',
        });
      }
    }
  };

  trackEvent = event => {
    const { auth, location, title } = this.props;
    const pageName = location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';
    Mixpanel.track(event, {
      name: title,
      type: 'video',
      page: finalPageName,
    });
  };

  render() {
    const { classes, isBig, isCard, title } = this.props;
    const { url, thumbnail_url, html } = this.state;
    if (_isEmpty(url) && _isEmpty(thumbnail_url)) return <LoadingIndicator />;
    return (
      <div
        href={url}
        className={
          _isEmpty(html)
            ? ClassNames(
                classes.thumbnail,
                isBig ? classes.bigThumbnail : classes.smallThumbnail,
              )
            : ClassNames(isBig ? classes.bigVideo : undefined)
        }
      >
        {!_isEmpty(html) ? (
          <div
            ref={ref => (this.videoContainer = ref)}
            className={ClassNames(
              classes.root,
              isBig ? classes.bigVideo : undefined,
              !isCard ? classes.rootSection : undefined,
            )}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        ) : (
          <img src={thumbnail_url} className={classes.image} alt={title} />
        )}
      </div>
    );
  }
}

VideoEmbedly.propTypes = {
  auth: PropTypes.object,
  classes: PropTypes.object,
  imageUrl: PropTypes.any,
  isBig: PropTypes.bool,
  title: PropTypes.string,
  url: PropTypes.string,
  location: PropTypes.object,
};

VideoEmbedly.defaultProps = {
  isCard: true,
};

export default compose(
  withRouter,
  withStyles(styles),
)(VideoEmbedly);
